import styled from 'styled-components';
import { flatUnderline, light } from './styledThemes';
export const TabHeaderWrapper = styled.div `
  position: relative;
  width: 100%;

  &.withPadding {
    padding-left: 15px;
    padding-right: 15px;
  }
`;
export const TabContent = styled.div `
  display: flex;
  width: 100%;
`;
export const TabContentWrapper = styled.div `
  display: flex;
  width: 100%;

  &.withMargin {
    margin-top: 1.25rem;
  }

  &.withPadding {
    padding-top: 1.25rem;
  }
`;
export const TabComponent = styled.div `
  display: flex;
  width: 100%;
`;
export const NavItemLink = styled.a `
  position: relative;
`;
export const TabsBox = styled.div `
  width: 100%;

  .nav {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
  }

  .nav-link {
    display: block;
    padding: 0.5rem 1rem;
  }

  .nav-link:hover,
  .nav-link:focus {
    text-decoration: none;
  }

  .nav-link.disabled {
    color: #6c757d;
    pointer-events: none;
    cursor: default;
  }

  .nav-tabs {
    border-bottom: 1px solid #dee2e6;
  }

  .nav-tabs .nav-item {
    margin-bottom: -1px;
  }

  .nav-tabs .nav-link {
    border: 1px solid transparent;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  .nav-tabs .nav-link:hover,
  .nav-tabs .nav-link:focus {
    border-color: #e9ecef #e9ecef #dee2e6;
  }

  .nav-tabs .nav-link.disabled {
    color: #6c757d;
    background-color: transparent;
    border-color: transparent;
  }

  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    color: #495057;
    background-color: #fff;
    border-color: #dee2e6 #dee2e6 #fff;
  }

  .nav-tabs .dropdown-menu {
    margin-top: -1px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .tab-title {
    white-space: nowrap;
  }
  .nav-link {
    padding: 10px 1em;

    .tab-icon {
      max-height: calc(40px - 20px);
      max-width: 56px;
      margin-right: 10px;
    }
  }

  &.flatUnderline {
    ${flatUnderline};
  }
  &.light {
    ${light};
  }

  @media (max-width: 768px) {
    &.light {
      .tab-content {
        padding: 0 15px;
      }
    }
  }
`;
